/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */
import { logger } from '@touchplan/logging';

export class ColorUtils {
	public static rgbToHex(color: string): string | undefined {
		const match: RegExpExecArray = ColorUtils.getRgbMatch(color);
		if (!match || match.length < 4) {
			logger.warn('Incorrect RGB format.');
			return undefined;
		}

		return `#${ColorUtils.componentToHex(match[1])}${ColorUtils.componentToHex(
			match[2]
		)}${ColorUtils.componentToHex(match[3])}`;
	}

	public static componentToHex(c: number | string): string {
		const color: number = typeof c === 'number' ? c : parseInt(c, 10);
		const hex = color.toString(16);
		return hex.length === 1 ? '0' + hex : hex;
	}

	/*
	 * supports both rga(0, 0, 0) or rgba(1, 1, 1, 1);
	 */
	public static getRgbMatch(color: string): RegExpExecArray {
		const regex: RegExp = /rgb[a]?\((\d{1,3}), (\d{1,3}), (\d{1,3})[, ]?(.*?)\)/;
		const match: RegExpExecArray = regex.exec(color);
		return match;
	}
}
